import { render, staticRenderFns } from "./BundleProduct.vue?vue&type=template&id=043c26fe&scoped=true&"
import script from "./BundleProduct.vue?vue&type=script&lang=js&"
export * from "./BundleProduct.vue?vue&type=script&lang=js&"
import style0 from "./BundleProduct.vue?vue&type=style&index=0&id=043c26fe&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043c26fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,IconWishlist: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/dynamic/IconWishlist.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,SvgIconDownArrow: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconDownArrow.vue').default})
